module.exports = {"name":"pswebmaf","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-01-12","repo":"https://bitbucket.org/npaw/pswebmaf-adapter-js","libVersion":"6.1.8","features":{"buffer":"native","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getThroughput","getRendition","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0